export default "/dist/files/like.29c726a2a8e073012079953362a126df.svg";